import PropTypes from 'prop-types'
import React from 'react'
import { Notification } from 'react-notification'

export const FormNotification = ({isActive, message, onClose}) =>
  <Notification isActive={isActive} message={message || ''} action={'Sakrij'} onClick={onClose} />

FormNotification.propTypes = {
  isActive: PropTypes.bool.isRequired,
  message: PropTypes.string,
  onClose: PropTypes.func.isRequired
}

FormNotification.defaultProps = {
  isActive: false
}
